// Module
var code = "<svg aria-hidden=\"true\" width=\"7\" height=\"28\"><path fill=\"currentColor\" d=\"M6.5 14 .5 0H0v28h.5z\"/><path fill=\"#858585\" d=\"M1 0H0l6 14-6 14h1l6-14z\"/></svg>";
// Exports
module.exports = code;